module.exports = __webpack_public_path__ + "static/media/img-avatar.eecc30e9.jpg";